import { useFrame } from "@react-three/fiber";
import { easing } from "maath";
import { useRef, useState } from "react";
import * as THREE from 'three'

const HeroImage = () => {
  const fragmentShader = `
  uniform float iTime;
  uniform vec2 iResolution;

  vec3 palette(float d){
    return mix(vec3(0.2,0.7,0.3),vec3(0.,0.,0.),d);
  }

  vec2 rotate(vec2 p,float a){
    float c = cos(a);
      float s = sin(a);
      return p*mat2(c,s,-s,c);
  }

  float map(vec3 p){
  // p *= 1.8;
  // p.y *= 1.5;
      for( int i = 0; i<8; ++i){
          float t = iTime*0.2;
          p.xz =rotate(p.xz,t);
          p.xy =rotate(p.xy,t*1.89);
          p.xz = abs(p.xz);
          p.xz-=.5;
    }
    return dot(sign(p),p)/5.;
  }

  vec4 rm (vec3 ro, vec3 rd){
      float t = 0.;
      vec3 col = vec3(0.);
      float d;
      for(float i =0.; i<64.; i++){
      vec3 p = ro + rd*t;
          d = map(p)*.5;
          if(d<0.02){
              break;
          }
          if(d>100.){
          break;
          }
          col+=palette(length(p)*.1)/(400.*(d));
          t+=d;
      }
      return vec4(col,1./(d*100.));
  }
  void mainImage( out vec4 fragColor, in vec2 fragCoord )
  {
      vec2 uv = (fragCoord-(iResolution.xy/2.))/iResolution.x;
    vec3 ro = vec3(0.,0.,-50.);
      ro.xz = rotate(ro.xz,iTime);
      vec3 cf = normalize(-ro);
      vec3 cs = normalize(cross(cf,vec3(0.,1.,0.)));
      vec3 cu = normalize(cross(cf,cs));
      
      vec3 uuv = ro+cf*3. + uv.x*cs + uv.y*cu;
      
      vec3 rd = normalize(uuv-ro);
      
      vec4 col = rm(ro,rd);
      fragColor = col;
  }

  varying vec2 vUv;
  void main() {
    mainImage(gl_FragColor, vUv * iResolution.xy);
  }
  `

  const vertexShader = `varying vec2 vUv;
  void main() {
      vUv = uv;
      gl_Position = projectionMatrix * modelViewMatrix * vec4( position, 0.5 );
  }`


  const [uni] = useState({
    iTime: { value: 1.0 },
    iResolution: { type: 'v2', value: new THREE.Vector2(1000, 1000) }
  })

  useFrame(({ clock }) => {
    uni.iTime.value = clock.getElapsedTime()
  })

  function CameraRig({ children }) {
    const group = useRef()
    useFrame((state, delta) => {
      easing.damp3(state.camera.position, [0, 0, 5], 0.25, delta)
      easing.dampE(group.current.rotation, [0, -state.pointer.x / 5, 0], 0.25, delta + 0.5)
    })
    return <group ref={group}>{children}</group>
  }

  return (
    <CameraRig>
      <mesh scale={[4.5, 5, 5]}>
        <planeGeometry arg={[1, 1]} />
        <shaderMaterial
          depthWrite={true}
          fragmentShader={fragmentShader}
          vertexShader={vertexShader}
          uniforms={uni}
          attach="material"
          opacity={1}
          alphaTest={.1}
        />
      </mesh>
    </CameraRig>

  )
}

export default HeroImage;